import * as React from 'react';

import { Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { UnresolvedDetails } from '@hydra/common/error';
import { Icon, Translate } from '@hydra/common/components';

import { getHostname } from '@hydra/utils/urlUtil';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    marginRight: theme.spacing(3)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1)
  },
  dialogContent: {
    '& .MuiPaper-root': {
      marginTop: 0
    }
  }
}));

function ErrorDetails ({ error }) {
  if (!error) {
    return null;
  }
  switch (error.errorCode) {
    case 'INVALID_URL':
      return <Translate content='generation_form_invalid_url' />;
    case 'UNRESOLVABLE_URL':
      return <UnresolvedDetails error={error} />;
    case 'NO_HOMEPAGE_URL':
      return (
        <Translate
          content='generation_form_review_homepage'
          with={{ domain: getHostname(error.url) }}
        />
      );
    default:
      return <Translate content='error_oops' />;
  }
}

export default function GenerationErrorDialog ({
  error,
  open,
  onClose,
  title = 'generation_form_unresolvable_url',
  banner = null
}) {
  const classes = useStyles();
  return (
    <Dialog
      open={open || false}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        {title && <Translate component='h4' content={title} />}
        {onClose && (
          <IconButton className={classes.closeButton} onClick={onClose}>
            <Icon type='cross' size='sm' />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {banner}
        <ErrorDetails error={error} />
      </DialogContent>
    </Dialog>
  );
}
